export default function DosDonts() {
  const dos = [
    'Ventilar con cuidado (sin corrientes fuertes)',
    'Fotografiar todo antes de tocar nada',
    'Contactar al seguro y a profesionales',
    'Proteger objetos de valor no dañados',
    'Documentar todos los daños visibles',
    'Esperar aprobación del perito si hay seguro'
  ];

  const donts = [
    'No limpiar con agua sola (fija el hollín)',
    'No usar aspiradora doméstica (dispersa partículas)',
    'No habitar el espacio sin saneamiento',
    'No tirar enseres sin consultar al perito',
    'No intentar limpiar sin equipos adecuados',
    'No retrasar la limpieza (el hollín oxida)'
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif font-bold text-4xl md:text-5xl text-primary mb-6">
            Qué hacer y qué evitar tras un incendio
          </h2>
          <p className="text-textLight text-lg max-w-2xl mx-auto">
            Actuar correctamente en las primeras horas puede marcar la diferencia en la recuperación de tu espacio.
          </p>
        </div>

        {/* Two Column Comparison */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* DO Column */}
          <div className="bg-[#E8F5E9] rounded-lg p-8 border-l-4 border-accent">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-accent rounded-full flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-white text-2xl"></i>
              </div>
              <h3 className="font-sans font-bold text-2xl text-primary">
                SÍ Hacer
              </h3>
            </div>
            <ul className="space-y-4">
              {dos.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-check-line text-accent text-xl mt-0.5 flex-shrink-0"></i>
                  <span className="text-textPrimary text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* DON'T Column */}
          <div className="bg-[#FFEBEE] rounded-lg p-8 border-l-4 border-[#E57373]">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-[#E57373] rounded-full flex items-center justify-center">
                <i className="ri-close-circle-fill text-white text-2xl"></i>
              </div>
              <h3 className="font-sans font-bold text-2xl text-primary">
                NO Hacer
              </h3>
            </div>
            <ul className="space-y-4">
              {donts.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-close-line text-[#E57373] text-xl mt-0.5 flex-shrink-0"></i>
                  <span className="text-textPrimary text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="text-center mt-12">
          <p className="text-textLight mb-6">
            ¿Tienes dudas sobre qué hacer después de un incendio?
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/faq"
              className="inline-block text-secondary font-sans font-semibold hover:text-primary transition-colors cursor-pointer"
            >
              Consulta las preguntas frecuentes →
            </a>
            <a
              href="/contacto"
              className="inline-block text-secondary font-sans font-semibold hover:text-primary transition-colors cursor-pointer"
            >
              Contacta con nosotros →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}